// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wlhmTucPB98WnUSAdTrq{max-width:140px}.MAx1XCHvcF4s_O66NhrV{align-items:center;gap:10px;padding:8px 12px}.SbJa_utP8ulLBAKWhVqw{height:40px}.cQo3aa13NnQSdo3oahf5{margin-top:8px}.MePyPXyYro48phqqZC_r{background:var(--white-100);z-index:var(--zIndex-BASE_10);margin-top:32px;padding-bottom:24px;position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedItem": `wlhmTucPB98WnUSAdTrq`,
	"inboxPlaceholderWrap": `MAx1XCHvcF4s_O66NhrV`,
	"assignButton": `SbJa_utP8ulLBAKWhVqw`,
	"seatPriceSection": `cQo3aa13NnQSdo3oahf5`,
	"actions": `MePyPXyYro48phqqZC_r`
};
export default ___CSS_LOADER_EXPORT___;
